import { arrayFilter } from '@/app/utils/nativeArray';
import type { editor } from './types';
import { getterTypes } from './types';
import { base } from '@/app/editor/sidebar/constant';
import type { GetterTree } from 'vuex';
import type { RootState } from '..';

const getters: GetterTree<editor, RootState> = {
  [getterTypes.EXIST_KEY_DATA_SETTING](state: editor) {
    return (key: string) => {
      if (!key) return false;
      if (state.dataSettings && state.dataSettings[key]) return true;
      return false;
    };
  },
  [getterTypes.GET_DATA_SETTING_BY_KEY](state: editor) {
    return (key: string) => {
      if (!key) return '';
      if (state.dataSettings && state.dataSettings[key]) return state.dataSettings[key];
      return '';
    };
  },
  [getterTypes.GET_BEFORE_STYLE_PREVIEW_MODE](state: editor) {
    return (key: string) => {
      if (!key) return '';
      if (state.beforeStylePreviewModeGlobalStyle && state.beforeStylePreviewModeGlobalStyle[key])
        return state.beforeStylePreviewModeGlobalStyle[key];
      return '';
    };
  },
  [getterTypes.UPDATE_DATA_SETTING_BY_KEY](state: editor) {
    return (key: string, newData: string) => {
      if (!key) return '';
      if (state.dataSettings && state.dataSettings[key]) return (state.dataSettings[key] = newData);
      return '';
    };
  },

  [getterTypes.GET_ANIMATION_ACTION_SETTING_BY_KEY](state: editor) {
    return (key: string) => {
      if (!key) return '';
      if (state.animations && state.animations.actions[key]) return state.animations.actions[key];
      return '';
    };
  },

  [getterTypes.GET_ANIMATION_INTERACTION_SETTING_BY_KEY](state: editor) {
    return (key: string) => {
      if (!key) return '';
      if (state.animations && state.animations.interactions[key]) return state.animations.interactions[key];
      return '';
    };
  },

  [getterTypes.GET_ANIMATION_DATA](state: editor) {
    return (key: string) => {
      if (!key) return '';
      if (key === 'action') {
        if (state.animations && state.animations.actions) return state.animations.actions;
      } else {
        if (state.animations && state.animations.interactions) return state.animations.interactions;
      }
      return '';
    };
  },

  [getterTypes.GET_ANIMATION_ACTION](state: editor) {
    if (state.animations && state.animations.interactions) return state.animations.interactions;
    return '';
  },

  [getterTypes.GET_SNIPPETS_BY_KEY](state: editor) {
    return (key: string) => {
      if (!key) return '';

      if (state.dataSnippets && state.dataSnippets[key]) return state.dataSnippets[key];
      return '';
    };
  },

  [getterTypes.GET_STYLE_SETTINGS](state: editor) {
    return () => {
      if (state.dataSettings) return Object.keys(state.dataSettings).filter((key) => key.startsWith(base._style));
      return [];
    };
  },

  [getterTypes.GET_ALL_STYLES](state: editor) {
    const entries = Object.entries(state.dataSettings);
    return arrayFilter(
      entries,
      (item) => {
        const key = item[0];
        return key.includes('style');
      },
      (item) => item[1],
    );
  },
  [getterTypes.GET_LOADING_DYNAMIC_DATA](state: editor) {
    return state.isLoadingDynamicData;
  },
};

export default getters;
